import { useSelector } from 'react-redux'
import { selectPrimaryLanguage } from '../../../services/user/selectors'
import { isDefault as isDefaultLanguage } from '../../../services/languages/index'

/**
 * Hook to determine if the current user's primary language is English.
 *
 * Returns true if the user's primary language is 'en' or 'en-US'.
 * Returns false for non-English languages or undefined (anonymous users).
 *
 * Used to conditionally show/hide features that are only available in English,
 * such as the Architect+ personality.
 */
export const useIsEnglishUser = (): boolean => {
  const language = useSelector(selectPrimaryLanguage)
  return isDefaultLanguage(language)
}
